// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageBox {
    border: 1px solid;
    border-left: 8px solid;
    border-radius: 15px;
    padding: 10px 20px;
}

.messageBox__header {
    margin: 8px 0;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/warningBox/MessageBox.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".messageBox {\n    border: 1px solid;\n    border-left: 8px solid;\n    border-radius: 15px;\n    padding: 10px 20px;\n}\n\n.messageBox__header {\n    margin: 8px 0;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
